import { useLoadDeviceEvents } from 'shared/hooks/events';
export function useDevicesEvents(device_ids) {
    const devicesEvents = [];
    let id = 1;
    device_ids.map((device_id) => {
        const { batches } = useLoadDeviceEvents(device_id, true);
        batches.forEach((batch) => {
            batch.localizedEvents.forEach((localizedEvent) => {
                devicesEvents.push({ id: id++, device_id, localizedEvent });
            });
        });
    });
    return { devicesEvents };
}
